import { onlineManager } from '@tanstack/react-query';
import { redirect } from '@tanstack/react-router';
import i18n from 'i18next';
import { useToastStore } from '~/modules/common/toaster/toast-store';

/** Asserts an entity is present (narrowing to NonNullable) or redirects to /home, toasting an offline cache miss. */
export function redirectOnMissing<T>(entity: T): asserts entity is NonNullable<T> {
  if (entity != null) return;
  if (!onlineManager.isOnline()) {
    useToastStore.getState().showToast(i18n.t('c:offline_cache_miss.text'), 'warning');
  }
  throw redirect({ to: '/home', replace: true });
}
